import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import VisibleIcon from '@rsuite/icons/Visible';
import { Link, useNavigate } from 'react-router-dom';
import globalIP from '../../GlobelIP';
import SortUpIcon from '@rsuite/icons/SortUp';
import LoadingBar from 'react-top-loading-bar';
import MenuIcon from '@rsuite/icons/Menu';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import useFilter from '../tables/members/Filters';
import FunnelIcon from '@rsuite/icons/Funnel';
import {
  Input,
  InputGroup,
  Button,
  Checkbox,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  FlexboxGrid,
  Container,
  Notification,
  IconButton,
  SelectPicker,
  Loader,
  Table
} from 'rsuite';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  // fetchMaterialCollection,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
  // fetchComponent,
  // fetchShape,
  // fetchSeason,
  // fetchPtechnique
} from '../.././apiService/apiService';
import SearchIcon from '@rsuite/icons/Search';
import { useInView } from 'react-intersection-observer';
// import AddedOnFIlter from '@/components/AddedOnFilter';
import HeaderFilter from '@/components/HeaderFilter';
import ProductCard from '@/components/ProductSearchPage/ProductCard';
import useLabel from '@/clientWeb/hook/Label';

import ugr from '@/UGRoute';
import Footer from '@/components/Footer/Footer';
import ProductQuickView from '@/components/ProductSearchPage/ProductQuickView';
import FilterDrawer from '@/components/FilterDrawer';
import ShowVariantModal from '@/components/ShowVariantModal';
import SortDrawer from '../tables/members/SortDrawer';
import ManageFair from '../manage/ManageFair';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const Selection = () => {
  const ipp = globalIP;

  const [data123, setData123] = useState([]);
  const [data11, setData11] = useState(null);
  const [meta123, setMeta123] = useState<MetaData>();
  const [selectedUnit, setSelectedUnit] = useState('');
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [progress, setProgress] = useState(0);
  const [limit, setLimit] = useState();
  const [imageList, setImageList] = useState([]);
  const [id, setId] = useState();
  const [selectedImagePath, setSelectedImagePath] = useState({ url: '', id: null, default: true });
  const { attributesName } = useLabel();
  const unitOptions = [
    { label: 'Inch', value: 'inch' },
    { label: 'CM', value: 'cm' }
  ];

  const [vardata, setVarData] = useState([]);

  useEffect(() => {
    if (id) {
      fetchData1234();
    }
  }, [id]);
  const fetchData1234 = async () => {
    const response = await fetch(`${ip}/api/products?populate=*&filters[id][$eq]=${id}`);
    const json = await response.json();
    // Concatenate data from all pages into a single array
    const extractedImageList = json.data
      .filter(item => item.attributes.MultipleImage && item.attributes.MultipleImage.data)
      .map(item => item.attributes.MultipleImage.data.map(image => image.attributes.url))
      .flat(); // Flatten the array of arrays
    const coverImage = json.data.map(item => item.attributes.CoverImage.data.attributes.url);
    extractedImageList.unshift(coverImage);
    const prefixed_list = extractedImageList.map(file => ip + file);
    setImageList(prefixed_list);
  };
  const [selectedImageIndex, setSelectedImageIndex] = useState({}); // Initial selected image index

   const getAllImages = item => {
  const cover = item?.attributes?.CoverImage?.data?.attributes?.url || '';

  const uniqueSortedMultipleImages =
    [...(item?.attributes?.MultipleImage?.data || [])]
      .filter(img => img?.attributes?.url?.trim())
      .filter(
        (img, index, self) =>
          index === self.findIndex(i => i.attributes.url === img.attributes.url)
      )
      .sort((a, b) =>
        a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase())
      )
      .map(img => img.attributes.url);

  return [cover, ...uniqueSortedMultipleImages];
};
  const handleNextImage = (item) => {
  const images = getAllImages(item);
  const currentIndex = selectedImageIndex[item.id] || 0;
  const nextIndex = (currentIndex + 1) % images.length;

  setSelectedImageIndex(prev => ({
    ...prev,
    [item.id]: nextIndex
  }));

  setSelectedImagePath({
    url: images[nextIndex],
    id: item.id,
    default: nextIndex === 0
  });
};

  const handlePrevImage = (item) => {
  const images = getAllImages(item);
  const currentIndex = selectedImageIndex[item.id] || 0;
  const prevIndex = (currentIndex - 1 + images.length) % images.length;

  setSelectedImageIndex(prev => ({
    ...prev,
    [item.id]: prevIndex
  }));

  setSelectedImagePath({
    url: images[prevIndex],
    id: item.id,
    default: prevIndex === 0
  });
};

  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedVarItems, setSelectedVarItems] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const handleCheckAll = checked => {
    if (filtersApplied) {
      const filteredProducts = applyFilters();
      setSelectedItems(prevSelectedItems => {
        const mergedItems = new Set([
          ...prevSelectedItems,
          ...(checked ? filteredProducts.map(item => item.id) : [])
        ]);
        return Array.from(mergedItems);
      });
    } else {
      setSelectedItems(checked ? data123.map(item => item.id) : []);
    }
    setIsAllSelected(checked);
  };

  const applyFilters = () => {
    let filteredProducts = data123;

    if (selectedCategory.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedCategory.includes(item.attributes.CategoryCode)
      );
    }

    if (selectedProductType.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedProductType.includes(item.attributes.ProductTypeCode)
      );
    }

    if (selectedColor.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedColor.includes(item.attributes.ColorCode)
      );
    }

    if (selectedFinish.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedFinish.includes(item.attributes.FinishCode)
      );
    }

    if (selectedhsn.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedhsn.includes(item.attributes.HSNCode)
      );
    }

    if (selectedmaterial.length > 0) {
      filteredProducts = filteredProducts.filter(item => {
        const materialCode = item.attributes.ProductionDetail[0]?.MaterialCode || '';
        return selectedmaterial.includes(materialCode);
      });
    }

    return filteredProducts;
  };
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
    }
  };

  // const handleToggleCart = itemId => {
  //   if (selectedItems.includes(itemId)) {
  //     setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== itemId));
  //   } else {
  //     setSelectedItems(prevSelectedItems => [...prevSelectedItems, itemId]);
  //   }
  // };
  const handleCartClose = () => {
    setIsCartOpen(false);
  };

  const [showDrawer, setShowDrawer] = useState(false);

  const AddedOn = [
    'Today',
    'Yesterday',
    'This week',
    'Last week',
    'This month',
    'Last month',
    'Last 3 month',
    'Last 6 month'
  ].map(item => ({ label: item, value: item }));

  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });

  // const [searchQryBtn, setSearchQryBtn] = useState(false);
  // let setSearchQryBtn = false;
  const [searchQuery, setSearchQuery] = useState('');
  const [clearSearchQuery, setClearSearchQuery] = useState(false);

  const [isLoadingTableData, SetIsLoadingTableData] = useState(false);
  useEffect(() => {
    // Determine if all items are selected
    if (filtersApplied) {
      const filteredProducts = applyFilters();
      setIsAllSelected(filteredProducts.every(item => selectedItems.includes(item.id)));
    } else {
      setIsAllSelected(data123.every(item => selectedItems.includes(item.id)));
    }
  }, [selectedItems, filtersApplied, data123]);
  const [sortAlias, setSortAlias] = useState(false);
  const [alsort, setAlsort] = useState('A');
  const fetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (selectedProductType.length > 0) {
      const protypeFilterString = selectedProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(
          color =>
            `filters[$or][0][ColorCode][$eq]=${color}&filters[$or][1][SetSizes][ColorCode][$eq]=${color}`
        )
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }
    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    if (selectedmaterial.length > 0) {
      const matFilterString = selectedmaterial
        .map(mat => `filters[ProductionDetail][MaterialCode][$eq]=${mat}`)
        .join('&');
      matFilter = `&${matFilterString}`;
    }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
      //  setCurrentPage(1)
    }

    let datefilter = '';
    let updateddatefilter = '';
    const formatDateToISO = date => date.toISOString();

    const getFirstDayOfWeek = date => {
      const firstDay = new Date(date);
      firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
      firstDay.setHours(0, 0, 0, 0);
      return formatDateToISO(firstDay);
    };

    const getFirstDayOfMonth = date => {
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);
      return formatDateToISO(firstDay);
    };

    const getFirstDayOfLastMonth = date => {
      const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      firstDayOfLastMonth.setHours(0, 0, 0, 0);
      return formatDateToISO(firstDayOfLastMonth);
    };

    const getLastDayOfLastMonth = date => {
      const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
      lastDayOfLastMonth.setHours(23, 59, 59, 999);
      return formatDateToISO(lastDayOfLastMonth);
    };

    const getDateDaysAgo = (date, days) => {
      const result = new Date(date);
      result.setDate(date.getDate() - days);
      result.setHours(0, 0, 0, 0);
      return formatDateToISO(result);
    };

    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
    const endOfToday = new Date(); // Current time

    switch (selectedDateRange) {
      case 'Today':
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
        break;

      case 'This week':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        datefilter = '';
        break;
    }

    switch (selectedUpdatedDateRange) {
      case 'Today':
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
        break;

      case 'This week':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        updateddatefilter = '';
        break;
    }
    let showsort = 'id:desc';
    if (alsort == 'B') {
      showsort = 'id:asc';
    }
    if (alsort == 'C') {
      showsort = 'ProductId:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductId:desc';
    } else if (alsort == 'F') {
      showsort = 'ProductCost:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductCost:desc';
    }
    let showpFilter = `&filters[Authorized][$eq]=Authorised`;
    const response = await fetch(
      `${ipp}/api/products?populate=*&sort[0]=${showsort}&pagination[page]=${currentPage}&${datefilter}${updateddatefilter}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${showpFilter}${searchQryFilter}`
    );

    const json = await response.json();
    setLimit(json.data.length);
    if (currentPage === 1) {
      setData123(json.data);
      setMeta123(json.meta);
    } else {
      setData123(prevData => [...prevData, ...json.data]);
      SetIsLoadingTableData(false);
      setMeta123(json.meta);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const ip = ipp;

  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc, setProgress);
  }, []);
  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchProductTypes(
        setProductypedata,
        isLoadingpro,
        setIsLoadingpro,
        selectedCategoryCode,
        selectedCategory
      );
    }
  }, [selectedCategoryCode, selectedCategory]);
  const [finishdata, setFinishData] = React.useState([]);
  const [isLoadingfin, setIsLoadingfin] = React.useState(false);
  useEffect(() => {
    fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin);
  }, []);

  const [materialdata, setMaterialdata] = useState([]);
  const [isLoadingmat, setIsLoadingmat] = useState(false);
  useEffect(() => {
    fetchMaterials(setMaterialdata, isLoadingmat, setIsLoadingmat);
  }, []);
  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, []);
  const [colordata, setColordata] = useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = useState(false);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, []);

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchSearchKeyword(setSearchdata, isLoadingse, setIsLoadingse);
  }, []);

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchProductName(setProdNamedata, isLoadingpron, setIsLoadingpron);
  }, []);

  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchProductDesign(setProdDdata, isLoadingprod, setIsLoadingprod);
  }, []);

  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchMadeBy(setMadedata, isLoadingmade, setIsLoadingmade);
  }, []);

  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadingalias] = useState(false);
  useEffect(() => {
    fetchAlias(setAliasdata, isLoadingalias, setIsLoadingalias);
  }, []);

  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadingsku] = useState(false);
  useEffect(() => {
    fetchSkuUnique(setSkudata, isLoadingsku, setIsLoadingsku);
  }, []);

  useEffect(() => {
    if (clearSearchQuery) {
      fetchData();
      //  TableFetchData();
    }
  }, [clearSearchQuery]);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    //  setPage(1);
    fetchData(); // Your data fetching function
    //  TableFetchData();  // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes

  useEffect(() => {
    fetchData();
    //  TableFetchData()
    setCurrentPage(1);
    //  setPage(1)
  }, [
    selectedUpdatedDateRange,
    selectedDateRange,
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedmaterial,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku,
    alsort
    //  authst
  ]);
  const handleFilterChange = (
    filterType,
    value,
    prevValue,
    clearSearchQuery,
    setClearSearchQuery
  ) => {
    const tempsearchq = searchQuery;
    setSearchQuery(''); // Clear the search query first

    const anyOtherFilterSelected =
      selectedCategory.length > 0 ||
      selectedProductType.length > 0 ||
      selectedColor.length > 0 ||
      selectedFinish.length > 0 ||
      selectedhsn.length > 0 ||
      selectedmaterial.length > 0 ||
      selectedBuyer.length > 0 ||
      selectedSearch.length > 0 ||
      selectedAlias.length > 0 ||
      selectedpron.length > 0 ||
      selectedpd.length > 0 ||
      selectedmade.length > 0 ||
      selectedsku.length > 0;

    // Handle setting clearSearchQuery flag
    if (anyOtherFilterSelected || prevValue.length === 0) {
      setClearSearchQuery(true);
    } else {
      setClearSearchQuery(false);
      setSearchQuery(tempsearchq);
    }

    // Set the filter state for the specific filter type
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'productType':
        setSelectedProductType(value);
        break;
      case 'color':
        setSelectedColor(value);
        break;
      case 'finish':
        setSelectedFinish(value);
        break;
      case 'hsn':
        setSelectedhsn(value);
        break;
      case 'material':
        setSelectedmaterial(value);
        break;
      case 'buyer':
        setSelectedBuyer(value);
        break;
      case 'search':
        setSelectedSearch(value);
        break;
      case 'alias':
        setSelectedAlias(value);
        break;
      case 'productName':
        setSelectedPron(value);
        break;
      case 'productDescription':
        setSelectedProd(value);
        break;
      case 'made':
        setSelectedMade(value);
        break;
      case 'sku':
        setSelectedSku(value);
        break;
      default:
        break;
    }

    // Reset pagination
    //  setPage(1);
    setCurrentPage(1);

    // Refetch data only after search query is cleared
    //  setReload((prev) => !prev);
  };

  // Update individual handlers
  const handleCategoryChange = value => {
    handleFilterChange('category', value, selectedCategory, clearSearchQuery, setClearSearchQuery);
  };
  const handleProductTypeChange = value => {
    handleFilterChange(
      'productType',
      value,
      selectedProductType,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleColorChange = value => {
    handleFilterChange('color', value, selectedColor, clearSearchQuery, setClearSearchQuery);
  };
  const handleFinishChange = value => {
    handleFilterChange('finish', value, selectedFinish, clearSearchQuery, setClearSearchQuery);
  };
  const handleHSNChange = value => {
    handleFilterChange('hsn', value, selectedhsn, clearSearchQuery, setClearSearchQuery);
  };
  const handleMaterialChange = value => {
    handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
  };
  const handleBuyerChange = value => {
    handleFilterChange('buyer', value, selectedBuyer, clearSearchQuery, setClearSearchQuery);
  };
  const handleSearchChange = value => {
    handleFilterChange('search', value, selectedSearch, clearSearchQuery, setClearSearchQuery);
  };
  const handleAliasChange = value => {
    handleFilterChange('alias', value, selectedAlias, clearSearchQuery, setClearSearchQuery);
  };
  const handleProNameChange = value => {
    handleFilterChange('productName', value, selectedpron, clearSearchQuery, setClearSearchQuery);
  };
  const handleProDChange = value => {
    handleFilterChange(
      'productDescription',
      value,
      selectedpd,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleMadeChange = value => {
    handleFilterChange('made', value, selectedmade, clearSearchQuery, setClearSearchQuery);
  };
  const handleSkuChange = value => {
    handleFilterChange('sku', value, selectedsku, clearSearchQuery, setClearSearchQuery);
  };

  const handleDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedUpdatedDateRange(value);
  };
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const [modeldata, setmodeldata] = useState([]);
  const [costid, setCostid] = useState(null);
  useEffect(() => {
    const item = modeldata[0]; // Assuming you want the first item in the array

    if (!item) {
      console.error('Item is undefined');
      return;
    }

    if (selectedImageIndex === 0) {
      console.log('imgindex : ' + selectedImageIndex);
      // When selected index is 0, set the CoverImage
      const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
      if (coverImageUrl) {
        setSelectedImagePath({
          url: coverImageUrl,
          id: item.id,
          default: true
        });
      } else {
        console.error('Cover image not found');
      }
    } else {
      console.log('imgindex11 : ' + selectedImageIndex);
      // Otherwise, set the corresponding MultipleImage
      const imageIndex = selectedImageIndex - 1; // Subtract 1 because CoverImage is index 0
      const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
      if (selectedImage && selectedImage?.attributes?.url) {
        setSelectedImagePath({
          url: selectedImage?.attributes?.url,
          id: item.id,
          default: true
        });
      } else {
        console.error('Multiple image not found at index', imageIndex);
      }
    }
  }, [selectedImageIndex, modeldata]);

  const handleOpen = (value, prdcd) => {
    setSize(value);
    setOpen(true);
    setId(prdcd);
    setCostid(prdcd);
    const newArray = [...data123];
    const filteredData = newArray.filter(item => item.id === prdcd);
    // setSelectedUnit(filteredData[0].attributes.SizeUnit)
    console.log('filteredData', filteredData);
    if (filteredData[0].attributes.SetStatus === 'Set') {
      setSelectedUnit(filteredData[0].attributes.SetSizes[0].SizeUnit);
      setData11(filteredData[0].attributes.SetSizes);
    } else {
      const data = [
        {
          Length: filteredData[0].attributes.Length,
          Width: filteredData[0].attributes.Width,
          Height: filteredData[0].attributes.Height,
          SizeUnit: filteredData[0].attributes.SizeUnit
        }
      ];
      setSelectedUnit(filteredData[0].attributes.SizeUnit);

      setData11(data);
    }
    setmodeldata(filteredData);
  };
  const handleClose = () => setOpen(false);
  const FixedLoader = () => (
    <Loader
      content="Loading..."
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '0',
        background: '#fff',
        width: '100%',
        padding: '4px 0'
      }}
    />
  );
  const renderMenu = menu => {
    return (
      <>
        {menu}
        {isLoadingse && <FixedLoader />}
      </>
    );
  };
  const renderMenu1 = menu => {
    return (
      <>
        {menu}
        {isLoadingalias && <FixedLoader />}
      </>
    );
  };
  const renderMenu2 = menu => {
    return (
      <>
        {menu}
        {isLoadingpron && <FixedLoader />}
      </>
    );
  };
  const renderMenu3 = menu => {
    return (
      <>
        {menu}
        {isLoadingprod && <FixedLoader />}
      </>
    );
  };
  const renderMenu4 = menu => {
    return (
      <>
        {menu}
        {isLoadingmade && <FixedLoader />}
      </>
    );
  };
  const renderMenu5 = menu => {
    return (
      <>
        {menu}
        {isLoadingsku && <FixedLoader />}
      </>
    );
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    if (inView && limit) {
      setCurrentPage(prev => prev + 1);
      console.log('Current Page change :', currentPage, 'Now : 1');

      SetIsLoadingTableData(true);
    }
  }, [inView]);

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);

  const [finShow, setFinShow] = useState(false);
  const [sizeshow, setSizeShow] = useState(false);
  const [sort, setSort] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      setFinShow(json.data[0].attributes.setFinish);
      setSort(json.data[0].attributes.SortBy);
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const [dataGrid, setDataGrid] = useState(6);
  const dataaaaa = [
    { label: 'Extra Small', value: 3 },
    { label: 'Small', value: 4 },
    { label: 'Medium', value: 6 },
    { label: 'Large', value: 8 },
    { label: 'Extra Large', value: 12 }
  ];

  const fetchDataVData = async id => {
    try {
      const response = await fetch(
        `${ip}/api/variant-products?filters[Variant_Id][$eq]=${id}&populate=*`
      );
      const json = await response.json();
      setVarData(json.data);
      return json.data;
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [varOpen, setVarOpen] = useState(false);
  const openVardata = id => {
    setVarOpen(true);
    fetchDataVData(id);
  };
  const selectallvar = async id => {
    const data = await fetchDataVData(id);
    if (data) {
      // Extract new IDs from the fetched data
      const newIds = data.map(row => row.id);
      setSelectedVarItems(prevSelectedItems => {
        // Check if all newIds are already in the selectedVarItems
        const allExist = newIds.every(newId => prevSelectedItems.includes(newId));

        if (allExist) {
          // If all newIds are present, remove them
          return prevSelectedItems.filter(item => !newIds.includes(item));
        } else {
          // If any newId is missing, add them
          return Array.from(new Set([...prevSelectedItems, ...newIds]));
        }
      });
    }
  };

  const [openSet, setOpenSet] = useState(false);
  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchHeads(setHead);
  }, []);
  // const fetchDataHeads = async () => {
  //   try {
  //     const response = await fetch(`${ip}/api/mstfilters?populate=*`);
  //     const json = await response.json();
  //     const filteredData = json.data.map(item => ({
  //       FilterName: item.attributes.FilterName,
  //       filterstatus: item.attributes.filterstatus
  //     }));
  //     setHead(filteredData);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  const handleSizeChange = value => {
    setSelectedUnit(value);
    const convertedData = convertDimensions(data11, value);
    setData11(convertedData);
  };

  // const convertDimensions = (dimensions, unit, sizeUnit) => {
  //   let convertedDimensions = dimensions;
  //   let finalUnit = unit;

  //   if (unit === 'inch' && sizeUnit === 'cm') {
  //     convertedDimensions = dimensions.map(dim => ({
  //       Length: inchToCm(dim.Length),
  //       Width: inchToCm(dim.Width),
  //       Height: inchToCm(dim.Height),
  //     }));
  //     finalUnit = 'cm';
  //   } else if (unit === 'cm' && sizeUnit === 'inch') {
  //     convertedDimensions = dimensions.map(dim => ({
  //       Length: cmToInch(dim.Length),
  //       Width: cmToInch(dim.Width),
  //       Height: cmToInch(dim.Height),
  //     }));
  //     finalUnit = 'inch';
  //   }

  //   return { dimensions: convertedDimensions, unit: finalUnit };
  // };
  const convertDimensions = (data, selectedUnit) => {
    const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

    return data.map(item => {
      // Skip conversion if the SizeUnit matches the selectedUnit
      if (item.SizeUnit === selectedUnit) {
        console.log('Unchanged data:', item);
        return item;
      }

      // Convert dimensions if SizeUnit does not match the selectedUnit
      let convertedItem = {
        ...item,
        Length: (item.Length || 0) * conversionFactor,
        Width: (item.Width || 0) * conversionFactor,
        Height: (item.Height || 0) * conversionFactor,
        SizeUnit: selectedUnit
      };

      console.log('Converted data:', convertedItem);
      return convertedItem;
    });
  };
  // useFilter(
  //   selectedCategory,
  //   selectedProductType,
  //   selectedColor,
  //   selectedFinish,
  //   selectedAlias,
  //   setAliasdata,
  //   setFinishData,
  //   setColordata,
  //   setCategorydata,
  //   setProductypedata
  // );
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        {/* <div
         style={{
          justifyContent:"space-between",
          width: '-webkit-fill-available',
          position: 'fixed',
          height: '186px',
          background: '#fff',
          zIndex: 1,
        }}
        > */}
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '180px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar  selection-head" justifyContent="space-between">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start">
                <Stack direction="row" alignItems="flex-start" spacing={140}>
                  <h3 className="title">Catalogue Create</h3>
                  <div onClick={() => setOpenSet(!openSet)}>
                    <MenuIcon className="catlgBurgerMenu" />
                  </div>
                </Stack>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to={`/${ugr}/dashboard`}>Home</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Select Product</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>
              <Stack spacing={5} className={openSet ? 'mange-item' : 'mange-search'}>
                <HeaderFilter
                  {...{
                    head,
                    label,
                    //data states
                    categorydata,
                    productypedata,
                    colordata,
                    proNamedata,
                    skudata,
                    buyernamedata,
                    finishdata,
                    aliasdata,
                    searchdata,
                    proDdata,
                    madedata,
                    hsndata,
                    materialdata,
                    setCategorydata,
                    setIsLoadingc,
                    isLoadingc,
                    SetIsLoadingTableData,
                    setProgress,
                    setColordata,
                    isLoadingcolor,
                    setIsLoadingcolor,
                    // setFinishdata,
                    isLoadingfin,
                    setIsLoadingfin,
                    setHsndata,
                    isLoadinghsn,
                    setIsLoadinghsn,
                    //selectedstates
                    selectedCategory,
                    selectedProductType,
                    selectedColor,
                    selectedpron,
                    selectedsku,
                    selectedBuyer,
                    selectedFinish,
                    selectedAlias,
                    selectedSearch,
                    selectedpd,
                    selectedmade,
                    selectedhsn,
                    selectedmaterial,
                    //onchangehandlers
                    selectedDateRange,
                    handleDatechange,
                    selectedUpdatedDateRange,
                    handleUpdatedDatechange,
                    handleCategoryChange,
                    handleProductTypeChange,
                    handleColorChange,
                    handleProNameChange,
                    handleSkuChange,
                    handleBuyerChange,
                    handleFinishChange,
                    handleAliasChange,
                    handleSearchChange,
                    handleProDChange,
                    handleMadeChange,
                    handleHSNChange,
                    handleMaterialChange,
                    //onopenfunctions
                    fetchCategory,
                    fetchColors,
                    fetchFinishes,
                    fetchProductTypes,
                    fetchAlias,
                    //rendermenus
                    renderMenu2,
                    renderMenu5,
                    renderMenu1,
                    renderMenu,
                    renderMenu3,
                    renderMenu4
                  }}
                />
                {/* <AddedOnFIlter
                  {...{
                    showboth: 'both',
                    AddedOn,
                    selectedDateRange,
                    handleDatechange,
                    selectedUpdatedDateRange,
                    handleUpdatedDatechange
                  }}
                /> */}
                <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                  More Filter
                </Button>
              </Stack>
            </Stack>

            <Stack
              direction="column"
              alignItems="flex-end"
              spacing={17}
              className="mange-search catalogue-search cat "
            >
              <Stack direction="row" spacing={5} className="selection-search">
                <InputGroup inside>
                  {/* <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                /> */}
                  <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={value => {
                      setSearchQuery(value);
                    }}
                    // onKeyDown={event => {
                    //   if (event.key === 'Enter') {
                    //     setSearchQryBtn = true;
                    //     searchQry();
                    //   }
                    // }}
                  />
                  <InputGroup.Addon>
                    <SearchIcon
                      onClick={() => {
                        // setSearchQryBtn = true;
                        // searchQry();
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </InputGroup.Addon>
                </InputGroup>
                {/* <Button onClick={searchQry}>Search</Button> */}
              </Stack>
              <Stack spacing={10} className="ctlog-slct" style={{ marginTop: '-10px' }}>
                {sort && (
                  <IconButton icon={<FunnelIcon />} active onClick={() => setSortAlias(true)} />
                )}
                <Checkbox
                  checked={isAllSelected}
                  onChange={(_, checked) => handleCheckAll(checked)}
                >
                  Select All
                </Checkbox>
                <SelectPicker
                  data={dataaaaa}
                  searchable={false}
                  style={{ width: 100 }}
                  size="md"
                  placeholder="Grid"
                  onChange={e => setDataGrid(!e ? 6 : e)}
                />
              </Stack>
            </Stack>
          </Stack>
          <Divider className="divide product-dvd" style={{ marginBottom: '10px' }} />
        </div>

        {/* </div> */}

        <div className="cat-row-image" style={{ marginTop: '168px' }}>
          <Panel>
            {(selectedCategory.length > 0 ||
              selectedProductType.length > 0 ||
              selectedColor.length > 0 ||
              selectedFinish.length > 0 ||
              selectedhsn.length > 0 ||
              selectedmaterial.length > 0 ||
              selectedBuyer.length > 0 ||
              selectedSearch.length > 0 ||
              selectedAlias.length > 0 ||
              selectedpron.length > 0 ||
              selectedpd.length > 0 ||
              selectedmade.length > 0 ||
              // searchQryBtn ||
              selectedsku.length > 0) && (
              <b style={{ marginLeft: '6px' }}>
                Total Products: {data123.length}/{meta123.pagination.total}
              </b>
            )}

            {/* {searchQryBtn &&  && (<b style={{ marginLeft: '6px' }}>Found Products: {data123.length}/{meta123.pagination.total}</b>)} */}

            {selectedCategory.length === 0 &&
              selectedProductType.length === 0 &&
              selectedColor.length === 0 &&
              selectedFinish.length === 0 &&
              selectedhsn.length === 0 &&
              selectedmaterial.length === 0 &&
              selectedBuyer.length === 0 &&
              selectedSearch.length === 0 &&
              selectedAlias.length === 0 &&
              selectedpron.length === 0 &&
              selectedpd.length === 0 &&
              selectedmade.length === 0 &&
              selectedsku.length === 0 &&
              meta123 && (
                <div style={{ marginLeft: '6px' }}>
                  <b style={{ marginLeft: '6px' }}>
                    Products: {data123.length}/
                    {data123.length == 0 ? data123.length : meta123.pagination.total}
                  </b>
                </div>
              )}
            <FlexboxGrid justify="start" style={{ textAlign: 'center' }}>
              {data123.map(item => (
                <ProductCard
                  {...{
                    item,
                    label,
                    dataGrid,
                    selectallvar,
                    openVardata,
                    handleCheckboxChange,
                    selectedItems,
                    handleOpen,
                    productUpdate: false,
                    pid: () => {},
                    showCheckbox: 1, // null means no preference
                    showEditIcon: 1, // null means no preference
                    showVariant: 1, // null means no preference
                    showQuickView: 1 // null means no preference
                  }}
                />
              ))}
            </FlexboxGrid>

            {(selectedItems.length > 0 || selectedVarItems.length > 0) && (
              <Notification
                type="success"
                onClose={handleCartClose}
                style={{
                  position: 'fixed',
                  top: '80%',
                  right: 20,
                  transform: 'translateY(-50%)',
                  zIndex: 9999,
                  background: '#0070a9',
                  color: 'white'
                  // width: '20%'
                }}
                className="view"
              >
                <b style={{ color: 'white' }}>
                  Selected Products : {selectedItems.length + selectedVarItems.length}
                </b>
                <Divider />
                <Link
                  to={{
                    pathname: `/${ugr}/editDetails`,
                    search: `?selectedItems=${selectedItems.join(
                      ','
                    )}&selectedVarItems=${selectedVarItems.join(',')}`
                  }}
                >
                  <IconButton icon={<VisibleIcon />}>
                    <b>View</b>
                  </IconButton>
                </Link>
              </Notification>
            )}
          </Panel>

          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
          {/* {isLoadingTableData && data123.length && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100px'
              }}
            >
              <Loader size="md" content="Loading..." style={{ color: 'red' }} />
            </div>
          )} */}
          {isLoading && <Loader center size="md" speed="fast" content="loading..." />}
          <Stack justifyContent="flex-end">
            <IconButton
              size="sm"
              icon={<SortUpIcon />}
              active
              onClick={scrollToTop}
              style={{
                position: 'fixed',
                top: '90%',
                right: 16,
                transform: 'translateY(-50%)',
                zIndex: 0
              }}
            />
          </Stack>
        </div>
        <FilterDrawer
          {...{
            showDrawer,
            setShowDrawer,
            head,
            label,
            //data states
            categorydata,
            productypedata,
            colordata,
            proNamedata,
            skudata,
            buyernamedata,
            finishdata,
            aliasdata,
            searchdata,
            proDdata,
            madedata,
            hsndata,
            materialdata,
            setCategorydata,
            setIsLoadingc,
            isLoadingc,
            SetIsLoadingTableData,
            setProgress,
            setColordata,
            isLoadingcolor,
            setIsLoadingcolor,
            // setFinishdata,
            isLoadingfin,
            setIsLoadingfin,
            setHsndata,
            isLoadinghsn,
            setIsLoadinghsn,
            //selectedstates
            selectedCategory,
            selectedProductType,
            selectedColor,
            selectedpron,
            selectedsku,
            selectedBuyer,
            selectedFinish,
            selectedAlias,
            selectedSearch,
            selectedpd,
            selectedmade,
            selectedhsn,
            selectedmaterial,
            selectedDateRange,
            handleDatechange,
            selectedUpdatedDateRange,
            handleUpdatedDatechange,
            //onchangehandlers
            handleCategoryChange,
            handleProductTypeChange,
            handleColorChange,
            handleProNameChange,
            handleSkuChange,
            handleBuyerChange,
            handleFinishChange,
            handleAliasChange,
            handleSearchChange,
            handleProDChange,
            handleMadeChange,
            handleHSNChange,
            handleMaterialChange,
            //onopenfunctions
            fetchCategory,
            fetchColors,
            fetchFinishes,
            fetchProductTypes,
            fetchAlias,
            fetchHsn,
            //rendermenus
            renderMenu2,
            renderMenu5,
            renderMenu1,
            renderMenu,
            renderMenu3,
            renderMenu4
          }}
        />
        <ProductQuickView
          {...{
            data11,
            label,
            handleClose,
            open,
            size,
            modeldata,
            handlePrevImage,
            handleNextImage,
            selectedImagePath,
            setSelectedImagePath,
            sizeshow,
            unitOptions,
            selectedUnit,
            handleSizeChange,
            convertDimensions,
            finShow,
            attributesName,
            costid
          }}
        />

        {/* <ManageFair 
       {...{
         costid
          }}
        /> */}
        {/* Variants modal */}
        <ShowVariantModal
          {...{
            varOpen,
            setVarOpen,
            vardata,
            selectedVarItems,
            setSelectedVarItems,
            label,
            fetchData,
            fetchDataVData
          }}
        />
        <Footer />
      </Container>
      {sortAlias && (
        <SortDrawer
          sortAlias={sortAlias}
          setSortAlias={setSortAlias}
          alsort={alsort}
          setAlsort={setAlsort}
        />
      )}
    </>
  );
};
export default Selection;
